module.exports = __webpack_public_path__ + "assets/media/2.eb48823f.wav";